import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			minWidth: 300,
			minHeight: '15rem',
			width: '95%',
			margin: '0 auto',
		},
		big: {
			position: 'fixed',
			top: '70%',
			[theme.breakpoints.down('xs')]: {
				display: 'none',
			},
		},
		small: {
			position: 'fixed',
			display: 'none',
			left: '10%',
			[theme.breakpoints.down('xs')]: {
				display: 'block',
			},
		},
	}),
);
